import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { OrganizationSettingsPage } from '../../components/OrganizationSettingsPage'

export const Route = createFileRoute('/$org/settings')({
  component: OrganizationSettings,
})

function OrganizationSettings() {
  // We need to decide whether to render the settings index page or delegate
  // to a sub-route via <Outlet />. TanStack Router nests children here, so
  // when the URL is exactly `/$org/settings` we render the index; otherwise
  // we let the child route take over.
  const matches = useMatches()
  const hasChild = matches.some(
    (m) => m.routeId.startsWith('/$org/settings/') && m.routeId !== '/$org/settings'
  )
  if (hasChild) {
    return <Outlet />
  }
  return <OrganizationSettingsPage />
}